<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :dense="showDense"
      fixed-header
      disable-pagination
      hide-default-footer
      disable-sort
      class="elevation-2"
    >
      <template v-slot:top>
        <v-row align="center" class="py-1 px-2" no-gutters>
          <v-col cols="12" sm="6">
            <v-breadcrumbs
              class="px-2"
              :items="breadcrumbsItems"
            ></v-breadcrumbs>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            :class="
              $store.getters.LANGUAGE == 'fa' ? 'text-left' : 'text-right'
            "
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  small
                  class="mx-2"
                  @click.stop="getReplies"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>fa-sync</v-icon>
                </v-btn>
              </template>
              <span>{{ $vuetify.lang.translator("refresh") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  small
                  class="mx-2"
                  @click="showDense = !showDense"
                  v-bind="attrs"
                  v-on="on"
                  :color="showDense ? 'success' : ''"
                >
                  <v-icon small>fas fa-compress-alt</v-icon>
                </v-btn>
              </template>
              <span>{{ $vuetify.lang.translator("compactView") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  small
                  class="mx-2"
                  v-bind="attrs"
                  v-on="on"
                  color="orange"
                  @click="helpDialog = true"
                >
                  <v-icon small>fa-question</v-icon>
                </v-btn>
              </template>
              <span>{{ $vuetify.lang.translator("showHelp") }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mx-3 mt-1">
          <v-col cols="12" sm="4">
            <div class="font-weight-bold">
              {{ $vuetify.lang.translator("subject") }}:
            </div>
            <div>{{ ticketSubject }}</div>
          </v-col>
          <v-col cols="12" sm="2">
            <div class="font-weight-bold">
              {{ $vuetify.lang.translator("priority") }}:
            </div>
            <div>{{ ticketPriority }}</div>
          </v-col>
          <v-col cols="12" sm="2">
            <div class="font-weight-bold">
              {{ $vuetify.lang.translator("attachment") }}:
            </div>
            <v-btn
              text
              small
              color="primary"
              v-if="ticketAttachment != null"
              :disabled="isDownloading"
              @click="downloadAttachment()"
            >
              <span v-if="isDownloading">{{ downloadPercentage }}%</span>
              <span v-else
                ><v-icon small>fa-download</v-icon
                >{{ $vuetify.lang.translator("downloadAttachment") }}</span
              >
            </v-btn>
          </v-col>
          <v-col cols="12" sm="2">
            <div class="font-weight-bold">
              {{ $vuetify.lang.translator("status") }}:
            </div>
            <div>{{ ticketStatus }}</div>
          </v-col>
          <v-col cols="12" sm="2">
            <div class="font-weight-bold">
              {{ $vuetify.lang.translator("createDate") }}:
            </div>
            <div class="ltr-text" v-if="$store.getters.LANGUAGE == 'fa'">
              {{ ticketDate | moment("jYYYY/jM/jD HH:mm") }}
            </div>
            <div class="ltr-text" v-else>
              {{ ticketDate | moment("YYYY/M/D HH:mm") }}
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mb-1">
          <v-col cols="12">
            <div class="font-weight-bold">
              {{ $vuetify.lang.translator("description") }}:
            </div>
            <div>{{ ticketDescription }}</div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </template>
      <template v-slot:item.index="{ item }">
        {{ items.indexOf(item) + 1 }}
      </template>
      <template v-slot:item.updated_at="{ item }">
        <div class="ltr-text" v-if="$store.getters.LANGUAGE == 'fa'">
          {{ item.updated_at | moment("jYYYY/jM/jD HH:mm") }}
        </div>
        <div class="ltr-text" v-else>
          {{ item.updated_at | moment("YYYY/M/D HH:mm") }}
        </div>
      </template>
      <template v-slot:footer>
        <v-divider></v-divider>
        <v-row class="mx-3 my-1">
          <v-col cols="12">
            <v-form
              ref="newForm"
              v-model="newValid"
              @submit.prevent="tryCreate"
            >
              <v-textarea
                v-model="fields.description"
                :rules="descriptionRules"
                :label="$vuetify.lang.translator('reply') + ' *'"
                clearable
              ></v-textarea>
              <v-btn
                color="primary"
                type="submit"
                :disabled="waitForNew"
                :loading="waitForNew"
              >
                <v-icon class="mx-2">fa-save</v-icon
                >{{ $vuetify.lang.translator("send") }}
              </v-btn>
            </v-form>
          </v-col>
        </v-row>
      </template>
    </v-data-table>

    <v-dialog
      v-model="helpDialog"
      persistent
      max-width="800"
      @keydown.esc="helpDialog = false"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-toolbar dense elevation="2">
          <v-toolbar-title>{{
            $vuetify.lang.translator("help")
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="helpDialog = false">
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <div
            class="mt-6"
            v-html="$vuetify.lang.translator('ticketHelp')"
          ></div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="success" @click="helpDialog = false">{{
            $vuetify.lang.translator("gotIt")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { required, max } from "@/helpers/validations";
import { handleError } from "@/helpers/helper";

export default {
  name: "Ticket",
  data: () => ({
    breadcrumbsItems: [],
    headers: [],
    items: [],
    newValid: false,
    fields: {
      description: ""
    },
    descriptionRules: [],
    loading: true,
    waitForNew: false,
    showDense: true,
    helpDialog: false,
    ticketID: 0,
    ticketSubject: "",
    ticketPriority: "",
    ticketStatus: "",
    ticketDate: "",
    ticketAttachment: null,
    ticketDescription: "",
    downloadPercentage: 0,
    isDownloading: false
  }),
  watch: {
    showDense: function() {
      this.$store.dispatch("saveShowDense", this.showDense ? "show" : "hide");
    }
  },
  created() {
    this.showDense = this.$store.getters.SHOWDENSE === "show";
    this.ticketID = this.$route.params.id;

    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("dashboard"),
      to: { name: "Dashboard" }
    });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("support"),
      to: { name: "Tickets" },
      exact: true
    });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("id") + " " + this.ticketID
    });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("requestSupport"),
      to: {
        name: "Ticket",
        params: { id: this.ticketID }
      }
    });

    this.headers.push({
      text: this.$vuetify.lang.translator("row"),
      value: "index",
      sortable: false,
      align: "center"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("user"),
      value: "user.name"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("description"),
      value: "description"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("updateDate"),
      value: "updated_at",
      sortable: false
    });

    this.getReplies();
  },
  methods: {
    getReplies() {
      this.loading = true;
      var self = this;
      this.$http
        .get("/ticket/" + this.ticketID + "/")
        .then(function(response) {
          self.ticketSubject = response.data.subject;
          self.ticketPriority = response.data.priority_title;
          self.ticketStatus = response.data.status_title;
          self.ticketDate = response.data.created_at;
          self.ticketDescription = response.data.description;
          self.ticketAttachment = response.data.attachment;
          self.items = response.data.ticket_replies;
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        })
        .then(function() {
          self.loading = false;
        });
    },
    tryCreate() {
      this.descriptionRules = [
        required(this.$vuetify.lang.translator("description"), this.$vuetify),
        max(1000, this.$vuetify.lang.translator("description"), this.$vuetify)
      ];
      let self = this;
      setTimeout(function() {
        if (self.$refs.newForm.validate()) {
          self.waitForNew = true;
          self.$http
            .post("/ticket/" + self.ticketID + "/", self.fields)
            .then(() => {
              self.$toasted.success(
                self.$vuetify.lang.translator("replySaved"),
                {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "check",
                  position: "top-center"
                }
              );
              self.getReplies();
              self.resetData();
            })
            .catch(error => {
              let result = handleError(
                error,
                self.$toasted,
                self.$router,
                self.$store
              );
              for (var item in result) {
                self.$toasted.error(result[item], {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "exclamation-triangle",
                  position: "top-center"
                });
              }
            })
            .then(function() {
              self.waitForNew = false;
            });
        }
      });
    },
    resetData() {
      this.descriptionRules = [];
      this.fields.description = "";
    },
    downloadAttachment() {
      this.isDownloading = true;
      this.downloadPercentage = 0;
      let self = this;
      this.$http
        .get("/ticket/" + this.ticketID + "/file/", {
          responseType: "blob",
          onDownloadProgress: function(event) {
            self.downloadPercentage = Math.round(
              (event.loaded * 100) / event.total
            );
          }
        })
        .then(response => {
          var filename = "attachment";
          var disposition = response.headers["content-disposition"];
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          const blob = new Blob([response.data], {
            type: "application/x-zip-compressed"
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          URL.revokeObjectURL(link.href);
          self.$toasted.success(
            self.$vuetify.lang.translator("downloadStarted"),
            {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "check",
              position: "top-center"
            }
          );
        })
        .catch(error => {
          if (
            error.response &&
            /json$/gi.test(error.response.headers["content-type"]) &&
            error.response.status === 400
          ) {
            self.$toasted.error(self.$vuetify.lang.translator("fileNotExist"), {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          } else {
            let result = handleError(error, self.$toasted, self.$router);
            for (var item in result) {
              self.$toasted.error(result[item], {
                duration: 5000,
                keepOnHover: true,
                className:
                  self.$store.getters.LANGUAGE == "fa"
                    ? "vazir-font-fd"
                    : "vazir-font",
                iconPack: "fontawesome",
                icon: "exclamation-triangle",
                position: "top-center"
              });
            }
          }
        })
        .then(function() {
          self.isDownloading = false;
        });
    }
  }
};
</script>
